import { GET_STORE_INFO_SUCCESS } from '../actionTypes/OrderActionTypes';

export default function StoreInfoReducer(state = {}, action) {
    // NOSONAR
    let newState = {};
    let store = '';
    switch (
        action.type // NOSONAR
    ) {
        case GET_STORE_INFO_SUCCESS:
            store = action.storeDetails;
            newState = { ...state };
            newState[store.id] = store;
            return newState;
        default:
            return state;
    }
}
